import React from 'react';
import {Grid, IconButton, Typography,} from "@mui/material";
import {GetState} from "../../../../redux/reduxhelper";
import {IS_AUTH} from "../../../../redux/action/type.action";
import {useNavigate} from "react-router";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {fixStringToHtml} from "../../../../tools/helper";

const EventItem = ({post = {}}) => {
    const isAuth = GetState(IS_AUTH, false)
    const navigate = useNavigate();
    return (
        <>
            <Grid sx={{
                padding: 2,
                borderRadius: 5,
                // border: '1px solid #000',
            }}>
                {isAuth && <Grid sx={{textAlign: "right"}}>
                    <IconButton onClick={() => navigate(`/admin/dashboard/event/${post?.id}`)}
                                sx={{color: "#592EA9", cursor: "pointer"}}
                    >
                        <EditOutlinedIcon/>
                    </IconButton></Grid>}
                <Grid sx={{
                    flexDirection: {md: 'row', xs: "column"},
                    justifyContent: "space-between",
                    display: 'flex',
                    alignItems: 'center',
                    margin: "10px"
                }}>
                    <Grid sx={{display: "flex", flexDirection: "column", padding: '10px'}}>

                        <Typography variant={'h4'} sx={{
                            color: '#232536',
                        }}>
                            {post?.title1}

                        </Typography>
                        <Typography variant={'h5'} sx={{color: '#592EA9', marginY: 2}}>
                            {post?.title2}
                        </Typography>
                        <Typography dangerouslySetInnerHTML={{
                            __html: fixStringToHtml(post?.description)
                        }} variant={'h6'} sx={{color: "#6D6E76"}}/>
                    </Grid>

                    <Grid sx={{display: "flex", height: {md: "250px", xs: "auto"}}}>
                        <img src={post?.image_url} alt={post?.title1}/>
                    </Grid>
                </Grid>
            </Grid>

        </>
    );
};

export default EventItem;